/*
  kischt page and cart fixes (28 Oct 2026)
  Works alongside the pack buy box (assets/kischt-pack-buybox.js) without changing it,
  the same way snippets/kischt-tights-upgrades.liquid does. Loaded on product pages by
  snippets/kischt-page-fixes.liquid. Settings come from the #kpxData JSON in that snippet.

  1. Add to cart stays live before a size is chosen. A tap points at the size buttons.
  2. One-tap fit answer above the size buttons, read from the line's size chart.
  3. Shade or pack tapped while the page is still loading switches in place.
  4. Bag: standard shipping and a delivered total, guarantee line, payment icons,
     and a one-tap "make it a pack" button on single items (tights keep their own).
*/
(function () {
  'use strict';

  var DATA = {};
  try {
    DATA = JSON.parse(document.getElementById('kpxData').textContent) || {};
  } catch (e) {
    DATA = {};
  }

  var ALIASES = { XXL: '2XL', XXXL: '3XL', XXXXL: '4XL', XXXXXL: '5XL', '2X': '2XL', '3X': '3XL', '4X': '4XL', '5X': '5XL', OS: 'ONESIZE', OSFA: 'ONESIZE' };

  function norm(value) {
    var s = String(value == null ? '' : value).toUpperCase().replace(/[\s-]+/g, '');
    return ALIASES[s] || s;
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    var value = Number(cents);
    if (!Number.isFinite(value)) return '';
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol', minimumFractionDigits: 2
      }).format(value / 100);
    } catch (e) {
      return '$' + (value / 100).toFixed(2);
    }
  }

  function route(path) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return base + String(path).replace(/^\/+/, '');
  }

  function post(path, payload) {
    return fetch(route(path), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error((data && data.description) || 'cart');
        return data;
      });
    });
  }

  function start() {
    var root = document.querySelector('[data-kpu-root]');
    if (!root) return;

    var config = {};
    try {
      config = JSON.parse(root.querySelector('script[data-kpu-config]').textContent) || {};
    } catch (e) {
      config = {};
    }
    config.products = config.products || [];
    config.bundles = config.bundles || [];

    function $(id) {
      return root.querySelector('#' + id) || document.getElementById(id);
    }

    var sizes = $('kpuSizes');
    var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

    function chosenSize() {
      var pressed = sizes && sizes.querySelector('[aria-pressed="true"]');
      return pressed ? pressed.getAttribute('data-kpu-size') : '';
    }

    // ---- 3. Shade or pack tapped before the buy box was ready --------------
    var pending = window.__kpxPendingHandle;
    window.__kpxPendingHandle = null;
    if (pending) {
      var target = root.querySelector('[data-kpu-colour="' + pending + '"], [data-kpu-bundle="' + pending + '"]');
      if (target && target.getAttribute('aria-pressed') !== 'true') target.click();
    }

    // ---- 1. Add to cart before a size ---------------------------------------
    var atc = $('kpuAddToCart');
    var atcLabel = $('kpuAddLabel');
    var prompt = null;

    if (sizes) {
      prompt = document.createElement('p');
      prompt.id = 'kpxSizePrompt';
      prompt.className = 'kpx-size-prompt';
      prompt.setAttribute('role', 'alert');
      prompt.hidden = true;
      prompt.textContent = 'Choose your size to add it to your bag.';
      sizes.insertAdjacentElement('afterend', prompt);
    }

    function showPrompt(scroll) {
      if (!sizes) return;
      if (prompt) prompt.hidden = false;
      sizes.classList.remove('kpx-attention');
      void sizes.offsetWidth;
      sizes.classList.add('kpx-attention');
      if (scroll) {
        sizes.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
        var first = sizes.querySelector('button:not(:disabled)');
        if (first) first.focus({ preventScroll: true });
      }
    }

    function hidePrompt() {
      if (prompt) prompt.hidden = true;
      if (sizes) sizes.classList.remove('kpx-attention');
    }

    function syncAtc() {
      if (!atc || !atcLabel) return;
      var text = atcLabel.textContent.trim();
      if (text === 'Choose a size') {
        atc.setAttribute('data-kpx-needs-size', 'true');
        atcLabel.textContent = 'Add to cart';
        return;
      }
      if (text !== 'Add to cart') atc.setAttribute('data-kpx-needs-size', 'false');
      if (atc.getAttribute('data-kpx-needs-size') === 'true' && atc.disabled) atc.disabled = false;
    }

    if (atc && atcLabel && window.MutationObserver) {
      new MutationObserver(syncAtc).observe(atcLabel, { childList: true, characterData: true, subtree: true });
      new MutationObserver(syncAtc).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
      syncAtc();
    }

    root.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('#kpuAddToCart');
      if (!button) return;
      if (button.getAttribute('data-kpx-needs-size') === 'true' && !chosenSize()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showPrompt(true);
      }
    }, true);

    root.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('[data-kpu-size]')) hidePrompt();
    });

    // The sticky bar lives outside the buy box once the page has loaded.
    var stickyLabel = document.getElementById('kpuStickyAddLabel');
    if (stickyLabel && window.MutationObserver) {
      var syncSticky = function () {
        if (stickyLabel.textContent.trim() === 'Choose a size') stickyLabel.textContent = 'Add to cart';
      };
      new MutationObserver(syncSticky).observe(stickyLabel, { childList: true, characterData: true, subtree: true });
      syncSticky();
    }
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('#kpuStickyAddToCart') && !chosenSize()) showPrompt(false);
    }, true);

    // ---- 2. One-tap fit answer ----------------------------------------------
    setupFit();

    function setupFit() {
      if (DATA.tights || !sizes || !config.sizeChartText) return;

      var lines = String(config.sizeChartText).split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
      if (lines.length < 3) return;

      var header = lines[0].split('|').map(function (c) { return c.trim(); });
      var rows = lines.slice(1).map(function (l) { return l.split('|').map(function (c) { return c.trim(); }); });

      var priority = [/^hip/i, /^fits bust$/i, /^bust$/i, /^weight$/i, /^waist$/i];
      var col = -1;
      for (var p = 0; p < priority.length && col < 0; p++) {
        for (var i = 1; i < header.length; i++) {
          if (priority[p].test(header[i]) && rows.every(function (r) { return String(r[i] || '').indexOf(';') !== -1; })) {
            col = i;
            break;
          }
        }
      }
      if (col < 0) return;

      function range(text) {
        var nums = String(text || '').match(/\d+(?:\.\d+)?/g);
        if (!nums) return null;
        var lo = Number(nums[0]);
        var hi = nums.length > 1 ? Number(nums[1]) : lo;
        if (/and up|\+/i.test(text)) hi = Infinity;
        return [lo, hi];
      }

      var byWeight = /lb/i.test(rows[0][col]);
      var units = byWeight ? ['lb', 'kg'] : ['in', 'cm'];
      var offered = Array.prototype.map.call(sizes.querySelectorAll('[data-kpu-size]'), function (b) {
        return b.getAttribute('data-kpu-size');
      });

      var table = rows.map(function (r) {
        var parts = String(r[col] || '').split(';');
        return { size: norm(r[0]), label: r[0], a: range(parts[0]), b: range(parts[1]) };
      }).filter(function (r) {
        return r.a && offered.indexOf(r.size) !== -1;
      });
      if (table.length < 2) return;

      var name = byWeight ? 'weight' : header[col].replace(/^fits\s+/i, '').toLowerCase();

      var box = document.createElement('div');
      box.className = 'kpx-fit-calc';
      box.innerHTML =
        '<label for="kpxFitValue">Find your size. Your ' + esc(name) + ':</label>' +
        '<span class="kpx-fit-inputs"><input id="kpxFitValue" type="number" inputmode="decimal" step="0.5" min="0" autocomplete="off" placeholder="' +
        (byWeight ? 'e.g. 150' : 'e.g. 40') + '"><select id="kpxFitUnit" aria-label="Unit">' +
        units.map(function (u) { return '<option value="' + u + '">' + u + '</option>'; }).join('') +
        '</select></span><p class="kpx-fit-result" aria-live="polite"></p>';
      sizes.insertAdjacentElement('beforebegin', box);

      var input = box.querySelector('input');
      var unit = box.querySelector('select');
      var out = box.querySelector('.kpx-fit-result');

      function answer() {
        var value = parseFloat(String(input.value).replace(',', '.'));
        if (!Number.isFinite(value) || value <= 0) {
          out.innerHTML = '';
          return;
        }
        var metric = unit.value === units[1];
        var list = table.map(function (r) {
          return { size: r.size, label: r.label, r: metric ? (r.b || r.a) : r.a };
        }).filter(function (r) { return r.r; });

        var hit = null;
        var note = '';
        for (var k = 0; k < list.length; k++) {
          if (value >= list[k].r[0] && value <= list[k].r[1]) { hit = list[k]; break; }
        }
        if (!hit) {
          var above = null;
          for (var m = 0; m < list.length; m++) {
            if (list[m].r[0] > value) { above = list[m]; break; }
          }
          if (!above) {
            out.innerHTML = '<span>That is above our largest size, ' + esc(list[list.length - 1].label) + '.</span>';
            return;
          }
          hit = above;
          note = above === list[0] ? ' Our smallest size.' : ' You are between sizes, so we went one up.';
        }

        var button = sizes.querySelector('[data-kpu-size="' + hit.size + '"]');
        var available = !!button && !button.disabled;
        var selected = chosenSize() === hit.size;

        out.innerHTML = '<span>Your size: <strong>' + esc(hit.label) + '</strong>.' + esc(note) + '</span>' +
          (selected ? '' : '<button type="button" class="kpx-fit-pick" data-kpx-pick="' + esc(hit.size) + '"' +
            (available ? '' : ' disabled') + '>' + (available ? 'Select ' + esc(hit.label) : esc(hit.label) + ' unavailable') + '</button>');
      }

      input.addEventListener('input', answer);
      unit.addEventListener('change', answer);
      out.addEventListener('click', function (event) {
        var pick = event.target.closest('[data-kpx-pick]');
        if (!pick || pick.disabled) return;
        var button = sizes.querySelector('[data-kpu-size="' + pick.getAttribute('data-kpx-pick') + '"]');
        if (button && !button.disabled) {
          button.click();
          setTimeout(answer, 0);
        }
      });
    }

    // ---- 4. Bag -------------------------------------------------------------
    var footer = $('kpuCartFooter');
    var body = $('kpuCartBody');
    var lastCart = null;
    var busy = false;
    var threshold = (config.freeShippingThresholds || {})[(window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'];
    var standard = Number(DATA.standardShipping) || 0;

    function colourEntry(handle) {
      for (var i = 0; i < config.products.length; i++) {
        if (config.products[i].handle === handle) return config.products[i];
      }
      return null;
    }

    function bundleEntry(handle) {
      for (var i = 0; i < config.bundles.length; i++) {
        if (config.bundles[i].handle === handle) return config.bundles[i];
      }
      return null;
    }

    // Same wording as the buy box's own pack line items (grouped by colour).
    function colourNames(b) {
      var order = [];
      var groups = {};
      (b.colours || []).forEach(function (raw) {
        var h = String(raw).trim();
        if (!groups[h]) {
          var c = colourEntry(h);
          var parts = h.split('|');
          var label = c ? c.shade : (parts.length > 1 ? (parts[1] || parts[0]).trim() : '');
          if (!label) return;
          groups[h] = { label: label, n: 0 };
          order.push(h);
        }
        groups[h].n += 1;
      });
      return order.map(function (h) {
        return (groups[h].n > 1 ? groups[h].n + ' x ' : '') + groups[h].label;
      }).join(' · ');
    }

    var catalog = {};
    (config.catalog || []).forEach(function (p) {
      if (p && p.handle) catalog[p.handle] = p;
    });

    function product(handle) {
      if (catalog[handle]) return Promise.resolve(catalog[handle]);
      return fetch(route('products/' + encodeURIComponent(handle) + '.js'), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) catalog[handle] = p; return p; })
        .catch(function () { return null; });
    }

    function variantFor(p, size) {
      if (!p || !p.variants) return null;
      var want = norm(size);
      var matches = p.variants.filter(function (v) {
        var opts = v.options || [v.option1, v.option2, v.option3];
        return opts.some(function (o) { return norm(o) === want; });
      });
      for (var i = 0; i < matches.length; i++) if (matches[i].available) return matches[i];
      return null;
    }

    function itemSize(item) {
      var opts = item.options_with_values || [];
      for (var i = 0; i < opts.length; i++) if (/size/i.test(opts[i].name)) return opts[i].value;
      return opts.length ? opts[opts.length - 1].value : '';
    }

    function decorateFooter(cart) {
      if (!footer || !cart || !cart.items || !cart.items.length) return;
      if (footer.querySelector('.kpx-cart-grand, .kpx-cart-trust')) return;

      var qualifies = threshold && Number(cart.total_price) >= threshold;
      var shipsFree = cart.requires_shipping === false || qualifies;
      var cost = shipsFree ? 0 : standard;

      if (cart.requires_shipping !== false && standard) {
        var rows = footer.querySelectorAll('.kpu-cart-total');
        Array.prototype.forEach.call(rows, function (row) {
          var spans = row.querySelectorAll('span');
          if (spans.length >= 2 && spans[0].textContent.trim() === 'Shipping') {
            spans[0].textContent = 'Standard shipping';
            spans[1].textContent = qualifies ? 'Free' : money(standard);
            if (qualifies) spans[1].className = 'kpx-free';
            var grand = document.createElement('div');
            grand.className = 'kpu-cart-total kpx-cart-grand';
            grand.innerHTML = '<span>Total</span><strong>' + esc(money(Number(cart.total_price) + cost)) + '</strong>';
            row.insertAdjacentElement('afterend', grand);
          }
        });
        var note = footer.querySelector('.kpu-checkout-note');
        if (note) note.textContent = 'Tax, if any, is added at checkout. Express shipping is also offered at checkout.';
      }

      if (DATA.trustHtml && !DATA.tights) {
        var checkout = footer.querySelector('.kpu-checkout');
        var holder = document.createElement('div');
        holder.className = 'kpx-cart-trust-wrap';
        holder.innerHTML = DATA.trustHtml;
        if (checkout) checkout.insertAdjacentElement('afterend', holder);
        else footer.appendChild(holder);
      }
    }

    function decorateItems(cart) {
      if (DATA.tights || !body || !cart || !cart.items || !cart.items.length) return;
      var nodes = body.querySelectorAll('.kpu-cart-item');
      if (nodes.length !== cart.items.length) return;

      var offered = 0;
      cart.items.forEach(function (item, index) {
        var host = nodes[index];
        if (!host || host.querySelector('.kpx-pack-upgrade') || offered >= 2) return;
        if (!colourEntry(item.handle) || bundleEntry(item.handle)) return;

        var size = itemSize(item);
        if (!size) return;

        var choices = config.bundles.filter(function (b) {
          return Number(b.count) > 1 && (b.colours || []).some(function (h) { return String(h).trim() === item.handle; });
        }).map(function (b) {
          var same = (b.colours || []).filter(function (h) { return String(h).trim() === item.handle; }).length;
          return { b: b, same: same };
        }).sort(function (x, y) {
          return (Number(x.b.count) - Number(y.b.count)) || (y.same - x.same);
        });
        if (!choices.length) return;
        offered += 1;

        (function tryNext(i) {
          if (i >= choices.length) return;
          var b = choices[i].b;
          product(b.handle).then(function (p) {
            var variant = variantFor(p, size);
            if (!variant) return tryNext(i + 1);
            if (!host.isConnected || host.querySelector('.kpx-pack-upgrade')) return;

            var count = Number(b.count);
            var qty = Number(item.quantity) || 0;
            var swap = Math.min(qty, count);
            if (!swap) return;

            var unitPrice = Number(item.final_price == null ? item.price : item.final_price);
            var packPrice = Number(variant.price);
            var diff = packPrice - unitPrice * swap;
            var more = count - swap;
            var unitWord = more === 1 ? (config.unit || 'item') : (config.unitPlural || 'items');

            var label = diff > 0
              ? 'Make it the ' + b.name + ': ' + more + ' more ' + unitWord + ' for ' + money(diff)
              : 'Switch to the ' + b.name + ' and save ' + money(-diff);
            var note = money(packPrice / count) + ' per ' + (config.unit || 'item') + ', all in size ' + size + '. ' + colourNames(b) + '.';
            if (threshold && Number(cart.total_price) < threshold && Number(cart.total_price) + diff >= threshold) {
              note += ' Shipping becomes free.';
            }

            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'kpx-pack-upgrade';
            button.innerHTML = esc(label) + '<small>' + esc(note) + '</small>';
            button.addEventListener('click', function () {
              if (busy) return;
              busy = true;
              button.disabled = true;
              var properties = { 'Bundle': b.name, 'Colours': colourNames(b) };
              properties[(config.copy && config.copy.perPackLabel) || 'Items per pack'] = String(count);
              // Add the pack first, then take the single pairs out, so a failed
              // step never leaves the shopper with less than they had.
              post('cart/add.js', { items: [{ id: variant.id, quantity: 1, properties: properties }] })
                .then(function () {
                  return post('cart/change.js', { id: item.key, quantity: Math.max(0, qty - swap) });
                })
                .catch(function () {
                  var msg = $('kpuCartMessage');
                  if (msg) {
                    msg.hidden = false;
                    msg.textContent = 'We could not switch that to a pack. Please check your bag and try again.';
                  }
                })
                .then(function () {
                  busy = false;
                  document.dispatchEvent(new CustomEvent('kischt:cart:refresh'));
                });
            });

            var info = host.querySelector('.kpu-cart-item-info') || host;
            info.appendChild(button);
          });
        })(0);
      });
    }

    function decorate() {
      if (!lastCart) return;
      decorateFooter(lastCart);
      decorateItems(lastCart);
    }

    document.addEventListener('kischt:cart:updated', function (event) {
      lastCart = event && event.detail && event.detail.cart;
      setTimeout(decorate, 0);
    });

    if (window.MutationObserver) {
      var queued = false;
      var queue = function () {
        if (queued) return;
        queued = true;
        setTimeout(function () { queued = false; decorate(); }, 0);
      };
      if (footer) new MutationObserver(queue).observe(footer, { childList: true });
      if (body) new MutationObserver(queue).observe(body, { childList: true });
    }

    // If the bag was already drawn before this script started, read it once.
    fetch(route('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (cart && !lastCart) {
          lastCart = cart;
          decorate();
        }
      })
      .catch(function () {});
  }

  // Start once the buy box script has set itself up (it marks its root with
  // data-kpu-ready). Speed apps sometimes delay theme scripts, so do not rely
  // on script order or on DOMContentLoaded alone.
  var started = false;

  function boot() {
    var root = document.querySelector('[data-kpu-root]');
    if (!root || started) return;

    function go() {
      if (started) return;
      started = true;
      start();
    }

    if (root.dataset.kpuReady === 'true') {
      go();
      return;
    }

    if (window.MutationObserver) {
      var watch = new MutationObserver(function () {
        if (root.dataset.kpuReady === 'true') {
          watch.disconnect();
          setTimeout(go, 0);
        }
      });
      watch.observe(root, { attributes: true, attributeFilter: ['data-kpu-ready'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
